<template>

<div>
<div class="companyHistory">

  <div class="container">

   <b-row align-h="end">
    <b-col cols="12" xs="12" sm="12" md="6" lg="4">
       <div class="mt-5 pt-5">
      <p class="font16 text-wight  mt-3 ">For more than 50 years, our founder William J. O&#39;Neil has been educating U.S. investors on the proven investing method he created. His investing classic "How to Make Money in Stocks" has sold more than 2 million copies worldwide. Now, for the first time, we're expanding to India to offer a tool focused on Indian stocks. Our goal, however, remains the same: </p>
      <p class="font16 text-wight  mt-3 ">To provide individual investors with the knowledge and information they need to achieve success in their investments and in their financial lives.</p>

      <p class="font16 text-wight  mt-3 text-center">"We don't believe in arguing with the reality of the marketplace."</p>

    <p class="font16 text-wight  mt-3 text-right">- William J. O&#39;Neil</p>
    </div>
    </b-col>
  </b-row>


  </div>
  </div>


<div class="companyceo">

  <div class="container">


  <b-row align-h="between">
    <b-col cols="12" xs="12" sm="12" md="6" lg="5" xl="4">


    <b-card text-variant="white" no-body class="overflow-hidden mt-5 mb-5" style="max-width: 540px; background-color:#000;border: 1px solid #ddd">
  <b-card-text class="font12 text-wight p-4 companyceoDis">
  <h4 class="font14">Accomplishments and Honors</h4>
  <ul>
    <li>Named one of the Top 100 Business Luminaries of the Century by TJFR Group and MasterCard International.
</li>
    <li>In 1988, Mr. O&#39;Neil was featured in the book Market Wizards by Jack D. Schwager.
</li>
    <li>In 2002, William O&#39;Neil receives the Classic Award of Recognition from the AeA, the largest high-tech industry group in the United States.
</li>
    <li>In 2004, The Stock Trader's Almanac devoted its 37th edition to Mr. O&#39;Neil.
</li>
    <li>In 2005, William O&#39;Neil received the prestigious Spirit of Lincoln award from the Lincoln Club of Los Angeles, recognizing him for his significant contributions to society in his research and efforts to develop a plan for jump-starting the American economy.
</li>
    <li>In 2012, Mr. O&#39;Neil founded the William J. O&#39;Neil Foundation for charitable, literary, and educational purposes.
</li>
    <li>In 2016, Mr. O&#39;Neil was named one of the Most Influential People in Los Angeles by The Los Angeles Business Journal.
</li>
    <li>CAN SLIM named best growth performing strategy by AAII in 2005 after an independent study showed the investing system returned a compound growth rate of 849.1% vs. S&P 500 28.8% from January 1998 - June 2005
</li>
    <li>Ranked 13 on Investopedia's list of  Greatest Investors</li>


  </ul>

          </b-card-text>
  </b-card>




    </b-col>
    <b-col cols="12" xs="12" sm="12" md="6" lg="5" xl="4">

     <div class="mt-5 pt-5">
      <p class="font16 text-wight  mt-3 ">My Philosophy is that all stocks are bad.
There are no good stocks unless they
go up in price. If they go down instead, you
have to cut your losses fast letting
losses run is the most serious mistake
made by most investors</p>


    <p class="font16 text-wight  mt-3 text-right">- William J. O&#39;Neil</p>
    </div>
<div class="mt-5 mb-3">
     <b-card text-variant="white" no-body class="overflow-hidden" style="max-width: 540px; background-color:#000;border: 1px solid #ddd">
    <b-row no-gutters>
      <b-col cols="4">
          <img width="100" src="@/assets/img/htmmis-book.jpg" class="bookImage">
      </b-col>
      <b-col cols="8">

          <b-card-text class="font12 text-wight p-4">
           An international bestseller that provides guidance to minimize risk and maximize gains, to build a generation of wealth for investors. This book is a magnum opus and has extensive details covered about the stock market. Neil's CANSLIM strategy is a time-tested strategy that demonstrates how the equity market works for different investors.
          </b-card-text>
        </b-card-body>
      </b-col>
    </b-row>
  </b-card>
  </div>

    </b-col>
  </b-row>


  </div>
  </div>






  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created(){
     window.scrollTo(0, 0);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/about.vue